<template>
  <div v-show="drawerVisible">
    <el-drawer title="录入人员"
               ref="drawer"
               :visible.sync="drawerVisible"
               :close-on-press-escape="false"
               @close="colseDrawer"
               :wrapperClosable="false"
               :append-to-body="true"
               size="78%">
      <div class="wrapper">
        <div class="row optional"></div>
        <el-row :gutter="20">
          <el-form ref="searchForm"
                   :model="searchForm"
                   label-width="70px"
                   size="small"
                   v-enterToNext="true">
            <el-col :lg="4"
                    :md="8"
                    :sm="12"
                    :xs="24">
              <el-form-item label="人员状态"
                            prop="isInsder">
                <el-select v-model="searchForm.state"
                           clearable
                           style="width: 100%"
                           placeholder="请选择状态">
                  <el-option v-for="item in statusList"
                             :key="item.Value"
                             :label="item.value"
                             :value="item.num"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="4"
                    :md="8"
                    :sm="12"
                    :xs="24">
              <el-form-item label="在职单位"
                            prop="isStore">
                <el-select v-model="searchForm.entryFactoryId"
                           clearable
                           filterable
                           @change="PositionList2"
                           placeholder="请选择">
                  <el-option v-for="item in companyList"
                             :key="item.Id"
                             :label="item.customerName"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="4"
                    :md="8"
                    :sm="12"
                    :xs="24">
              <el-form-item label="职位"
                            prop="isStore">
                <el-select v-model="searchForm.entryPositionId"
                           clearable
                           filterable
                           placeholder="请选择职位">
                  <el-option v-for="item in positionList"
                             :key="item.id"
                             :label="item.positionName"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="4"
                    :md="8"
                    :sm="12"
                    :xs="24">
              <el-form-item label-width="100px"
                            label="是否有身份证"
                            prop="isStore">
                <el-select v-model="searchForm.isHaveIdentityCard"
                           clearable
                           filterable
                           placeholder="请选择是否有身份证">
                  <el-option label="是"
                             :value="true"></el-option>
                  <el-option label="否"
                             :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="4"
                    :md="12"
                    :sm="12"
                    :xs="24">
              <el-form-item label="关键字"
                            prop="keyWord">
                <el-input @keyup.enter.native="handleSearch"
                          v-model="searchForm.keyWord"
                          clearable
                          placeholder="请输入关键字查询"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <el-button size="small"
                     style="margin-left: 15px"
                     type="primary"
                     plain
                     @click="handleSearch"
                     icon="el-icon-search">查询</el-button>
          <p style="
              float: right;
              margin-right: 15px;
              margin-top: 10px;
              text-decoration: underline;
              cursor: pointer;
              color: #409eff;
            "
             @click="addPersonnel">
            点击新增人员
          </p>
        </el-row>
        <div class="row table">
          <MyTable :tableData="tableData"
                   :tableConfig="tableConfig"
                   tableType="selection"
                   @selectionChange="handleSelectionChange"
                   :indexFlag="true"
                   @EmptyBtn="EmptyBtn"
                   tableEmptyText="暂无数据，请前往人员管理">
            <template v-slot:index="slotData">
              {{
                ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
                slotData.scope.$index +
                1
              }}
            </template>
            <template v-slot:state="slotData">
              {{ slotData.scope.row.state | state }}
            </template>
          </MyTable>

          <Pagination style="margin-top: 10px"
                      :total="total"
                      @getNewData="getPersonnelList"
                      ref="pagination" />
        </div>

        <div class="submit-bar">
          <el-button @click="colseDrawer"
                     :loading="submitLoading">关 闭</el-button>
          <el-button type="primary"
                     :loading="submitLoading"
                     @click="confirm">确 定</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- <AddPersonel
      :drawerShow="addCustomerDrawerShow"
      :title="drawerTitle"
      @colseDrawer="addCustomerDrawerShow = false"
      @refreshData="
        () => {
          getPersonnelList();
        }
      "
    /> -->
    <AddTalent :drawerShow="addUserDrawerShow"
               title="新增人员"
               type="0"
               operation="add"
               @colseDrawer="addUserDrawerShow = false"
               @refreshData="
        () => {
          getPersonnelList();
        }
      " />
  </div>
</template>

<script>
// import AddPersonel from "./AddPersonel";
import AddTalent from "../talent_center/AddTalent.vue";

import MyTable from "@/components/Table";
export default {
  components: {
    MyTable,
    AddTalent
  },
  props: {
    visible: {
      default: false,
      type: Boolean,
      require: true,
    },
    row: {
      default: () => {
        return {};
      },
      type: null,
      require: true,
    },
    onerow: {
      type: null,
    },
    filterate: {
      type: Array,
    },
    importName: String,
  },
  data () {
    return {
      tableName: "batchAddTable",
      tableConfig: [
        {
          field: "cname",
          label: "姓名",
          align: "center",
          width: 130,
          flag: true,
        },
        {
          field: "sex",
          label: "性别",
          align: "center",
          width: 130,
          flag: true,
        },
        {
          field: "identityCard",
          label: "身份证号",
          align: "center",
          width: 180,
          flag: true,
        },
        {
          field: "tel",
          label: "手机号码",
          align: "center",
          width: 140,
          flag: true,
        },
        {
          field: "state",
          label: "人员状态",
          align: "center",
          slotName: "state",
          width: 110,
          flag: true,
        },
        {
          field: "entryFactory",
          label: "在职单位",
          align: "center",
          minWidth: 160,
          flag: true,
        },
        {
          field: "entryPosition",
          label: "职位",
          align: "center",
          minWidth: 90,
          flag: true,
        },
        // {
        //   field: "positionName",
        //   label: "平台开卡",
        //   align: "center",
        //   width: 110,

        //   flag: true,
        // },
      ],
      rules: {
        bank: [
          {
            required: true,
            message: "请选择银行",
            trigger: ["blur", "change"],
          },
        ],
      },
      drawerVisible: false,
      form: {
        img: [],
      },
      statusList: [
        {
          value: "待处理",
          num: 1,
        },
        {
          value: "待面试",
          num: 2,
        },
        {
          value: "面试未通过",
          num: 3,
        },
        {
          value: "待入职",
          num: 4,
        },
        {
          value: "未入职",
          num: 5,
        },
        {
          value: "已入职",
          num: 6,
        },
        {
          value: "已离职",
          num: 8,
        },
        {
          value: "已离职(自离)",
          num: 7,
        },
      ],
      submitLoading: false,
      searchForm: {},
      tipVisible: false,
      dialogVisible: false,
      addCustomerDrawerShow: false,
      addUserDrawerShow: false,
      drawerTitle: "",
      loading: false,
      tableData: [],
      total: 0,
      companyList: [],
      positionList: [],
      tableHeight: "",
      Ids: [],
      customerIds: [],
      checked: false,
    };
  },
  filters: {
    state (num) {
      if (num == 1) {
        return "待处理";
      } else if (num == 2) {
        return "待面试";
      } else if (num == 3) {
        return "面试未通过";
      } else if (num == 4) {
        return "待入职";
      } else if (num == 5) {
        return "未入职";
      } else if (num == 6) {
        return "已入职";
      } else if (num == 7) {
        return "已离职(自离)";
      } else if (num == 8) {
        return "已离职";
      }
    },
  },
  mounted () {
    this.getCompanyList();
  },

  methods: {
    PositionList2 () {
      this.positionList = [];
      if (this.searchForm.entryFactoryId) {
        let sendData = {
          customerId: this.searchForm.entryFactoryId,
        };
        this.$api.posts.PositionAllList(sendData).then((res) => {
          if (res.error === false) {
            this.positionList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    confirm () {
      if (this.Ids.length <= 0) {
        return this.$message.warning("请至少选择一条数据");
      }
      // this.submitLoading = true;
      this.colseDrawer();
      this.$emit("add", this.Ids);
      // this.submitLoading = false;
    },
    addPersonnel () {
      this.addUserDrawerShow = true;
      // this.$router.push("/personnelList");
    },
    EmptyBtn () {
      // this.$router.push("/personnelList");
      this.addUserDrawerShow = true;
    },
    getCompanyList () {
      this.$api.customer.getAllCustomerList().then((res) => {
        if (res.error === false) {
          this.companyList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSearch () {
      this.$refs.pagination.currentPage = 1;
      this.$refs.pagination.pageSize = 20;
      this.getPersonnelList();
    },
    addAccount () {
      this.dialogVisible = true;
    },
    colseDrawer () {
      this.resetForm();
      this.drawerVisible = false;
      this.$emit("colseDrawer");
    },
    handleSelectionChange (selection) {
      this.Ids = selection.map((v) => {
        if (this.importName == "addTimesheet") {
          return v;
        } else if (this.importName == "rosterDetail") {
          this.$set(v, "name", v.cname);
          this.$set(v, "sex", v.sex);
          this.$set(v, "isVeteran", v.isVeteran);
          this.$set(v, "phone", v.tel);

          return v;
        } else {
          this.$set(v, "userName", v.cname);
          this.$set(v, "userId", v.id);
          this.$set(v, "insuranceWorkCategoryCode", v.occupationCode);
          this.$set(v, "workTypeCode", v.occupationCode);
          this.$set(v, "myName", v.standardName);
          this.$set(v, "insuranceWorkCategoryName", v.standardName);
          return v;
        }
      });
    },
    onSubmit (formName) {
      if (this.customerIds.length <= 0) {
        return this.$message.warning("请至少选择一条数据");
      }
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;
        let sendData = {
          factoryId: this.form.factoryId,
          positionId: this.form.positionId,
          userIds: this.customerIds,
        };
        this.$api.user.BatchApply(sendData).then((res) => {
          this.submitLoading = false;
          if (res.error === false) {
            this.batchRegistrationVisible = false;
            this.$parent.getCustomerList();
            this.$message.success("报名成功");
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    getPersonnelList () {
      let arry = [];

      if (this.filterate) {
        this.filterate.forEach((item) => {
          if (item.autoIntId) {
            arry.push(item.autoIntId);
          }
        });
      }

      this.loading = true;
      let Data = "";
      let sendData = {};
      this.$nextTick(() => {
        sendData = {
          pageIndex: this.$refs.pagination.currentPage,
          pageSize: this.$refs.pagination.pageSize,
          excludeAutoIntIdStrList: arry.join(","),
          state: this.searchForm.state,
          entryFactoryId: this.searchForm.entryFactoryId,

          entryPositionId: this.searchForm.entryPositionId,
          isHaveIdentityCard: this.searchForm.isHaveIdentityCard,
          keyWord: this.searchForm.keyWord,
        };

        this.$api.user.CompanyUserListPage(sendData).then((res) => {
          this.loading = false;
          if (!res.error) {

            this.tableData = res.data.data;

            this.total = res.data.count;
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },

    resetForm () {
      this.customerIds = [];
      this.form = {};
      // this.$refs.form.clearValidate();
    },
  },
  watch: {
    visible (newVal) {
      this.drawerVisible = newVal;
      if (newVal) {
        this.getPersonnelList();
      }
      if (newVal) {
        this.loading = false;
      }
    },
    drawerVisible (newVal) {
      this.$emit("update", newVal);
    },
  },
};
</script>
<style lang="less" scoped>
.submit-bar {
  position: absolute;
  z-index: 99;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 0;
  background-color: #fff;
  text-align: center;
  border-top: 1px solid #ddd;
  padding-right: 20px;
}
.submit-bar .el-button {
  padding: 8px 20px;
}
.el-table .cell {
  white-space: pre-line !important;
}

.wrapper {
  padding: 10px 20px;
}

button.btn {
  background: #0080ff;
  border: 0px;
  color: #fff;
  padding: 5px 10px;
  margin-right: 10px;
}

button.btn:hover {
  background: #004f9e;
  cursor: pointer;
}

.number-footer {
  width: 100px;
}

.myimg {
  width: 200px;
  height: auto;
}
</style>